import { render } from "./ComputerDetail.vue?vue&type=template&id=0ecbdf05&scoped=true"
import script from "./ComputerDetail.vue?vue&type=script&lang=js"
export * from "./ComputerDetail.vue?vue&type=script&lang=js"

import "./ComputerDetail.vue?vue&type=style&index=0&id=0ecbdf05&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecbdf05"]])

export default __exports__